// extracted by mini-css-extract-plugin
export var infoItem = "_tx-2";
export var title = "_tx-0";
export var value = "_tx-1";